module.exports = __webpack_public_path__ + "img/image-shape.f52b6cce.png";